/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_SelectInputs */

const en_directory_submit_review_select = /** @type {(inputs: Directory_Submit_Review_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose`)
};

const zh_directory_submit_review_select = /** @type {(inputs: Directory_Submit_Review_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择`)
};

/**
* | output |
* | --- |
* | "Choose" |
*
* @param {Directory_Submit_Review_SelectInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_select = /** @type {((inputs?: Directory_Submit_Review_SelectInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_SelectInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_select(inputs)
	return zh_directory_submit_review_select(inputs)
});
export { directory_submit_review_select as "directory.submit.review.select" }